export interface BrowserStorage {
    get: () => any;
    set: (value: any) => void;
    clean: () => void;
}

export const useBrowserStorage = <T>(key: string): BrowserStorage => {
    const get = () => {
        const storedValue = localStorage.getItem(key);
        return storedValue !== null ? JSON.parse(storedValue) : undefined;
    };

    const set = (value: T) => {
        localStorage.setItem(key, JSON.stringify(value));
    };

    const clean = () => {
        localStorage.removeItem(key);
    };

    return { get, set, clean };
};
